export default __webpack_public_path__ + "static/media/ambulance.bd3e0bc9.svg";